<div class="kng-item-card {{ state?.cssClass }}">
  <div class="container" [ngClass]="isServiceView ? 'raymond-min-height-alignment' : ''">
    <div *ngIf="state?.loading" class="loader">
      <img style="height: 100px;" src="{{loaderState.imagePath }}" tabindex="0" alt="loader" />
    </div>
    <div class="title-row" *ngIf="!state?.loading">
      <div class="card-title d-flex justify-content-between" tabindex="0">
        <p class="m-0">{{ state?.title?.label }}</p>
        <button *ngIf="isServiceView && !hideViewMoreButton" class="view-more">{{ state?.viewMoreButton }}</button>
      </div>
        <div class="card-title d-flex justify-content-between card-title-alt" tabindex="0" *ngIf="isIwTelematics">
          <p class="m-0">
            {{
              isIwTelematicsNotReporting
                ? state?.iwTelematicsLabels?.notReportingLabels?.title
                : isIwTelematicsByPassed
                ? state?.iwTelematicsLabels?.byPassedLabels?.title
                : ""
            }}
          </p>
        </div>
    </div>
    <div *ngIf="state?.unit && !state?.loading">
      <div class="kng-item-card--content-container" *ngFor="let unitItem of state?.unit">
        <div class="card-body-section" [ngClass]="{'align-start': ((state?.cardType === 'serviceManagementCard') && !isServiceView), 'card-body-section-alt': isIwTelematics}">
          <div class="card-icon" *ngIf="state?.image &&
              state?.image?.url !== '' && !isIwTelematics
            ">
            <img src="{{ state?.image?.url }}" alt="{{ state?.image?.alt }}" />
          </div>
          <div *ngIf="state?.error && !state?.loading" class="error">
            <img src="/assets/images/exclamation_alert_raymond.svg" tabindex="0" alt="error" />
            <div class="errorMessage">
              {{ state?.error }}
            </div>
          </div>
          <div class="card-icon" *ngIf="isIwTelematics">
            <img [src]="isIwTelematicsNotReporting ? '/assets/images/ic_not_reporting.svg' : '/assets/images/ic_bypass.svg'" tabindex="0" alt="deviation" />
          </div>
          <div *ngIf="!state?.error && !state?.loading && state?.cardType === 'unitCard'" class="card-body-details" [ngClass]="{'no-details-card' : unitItem?.details?.length === 0,'card-body-details-alt' : isIwTelematics}">
            <div class="card-top" tabindex="0" [ngClass]="isIwTelematics ? 'card-top-alt': ''">
              <div class="card-label" tabindex="-1">
                {{ unitItem.label | roundoffDecimal : 0 }}
              </div>
              <div class="card-description" tabindex="-1">
                {{ unitItem?.description?.label }}
              </div>
              <div *ngIf="isIwTelematics">
                <div class="card-label" tabindex="-1">
                  <span class="percentage-value">{{
                    isIwTelematicsNotReporting
                      ? state?.iwTelematicsData?.notReporting?.percentage
                      : isIwTelematicsByPassed
                      ? state?.iwTelematicsData?.bypassed?.percentage
                      : " "
                  }}</span>
                </div>
                <div class="percentage-label">
                  {{
                    isIwTelematicsNotReporting
                      ? state?.iwTelematicsLabels?.notReportingLabels?.percentageLabel
                      : isIwTelematicsByPassed
                      ? state?.iwTelematicsLabels?.byPassedLabels?.percentageLabel
                      : ""
                  }}
                  <span class="out-of">
                    ( {{
                      isIwTelematicsNotReporting
                        ? state?.iwTelematicsData?.notReporting?.notReportingTrucks
                        : isIwTelematicsByPassed
                        ? state?.iwTelematicsData?.bypassed?.bypassedTrucks
                        : 0
                    }}
                    {{
                      isIwTelematicsNotReporting
                        ? state?.iwTelematicsLabels?.notReportingLabels?.countLabel
                        : isIwTelematicsByPassed
                        ? state?.iwTelematicsLabels?.byPassedLabels?.countLabel
                        : ""
                    }}
                    {{
                      isIwTelematicsNotReporting
                        ? state?.iwTelematicsData?.notReporting?.totalTrucks
                        : isIwTelematicsByPassed
                        ? state?.iwTelematicsData?.bypassed?.totalTrucks
                        : 0
                    }} )
                  </span
                  >
                </div>
              </div>
            </div>
            <div class="card-bottom" *ngIf="!isIwTelematics">
              <div class="card-bottom-item"
                [ngClass]="{'left-border': ( i % 2 !== 0 && i > 0 ), 'right-border': ( i % 2 === 0 && i > 0 ), 'card-bottom-alt' : isMyFleet}"
                *ngFor="let detail of unitItem?.details; let i = index">
                <div class="item-top">
                  {{ detail.header }}
                </div>
                <div class="item-bottom">
                  <div class="item-bottom-label">{{ detail.label | roundoffDecimal : 0 }}</div>
                  <div class="item-bottom-description">{{ detail.description.label }}</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!state?.error && !state?.loading && state?.cardType === 'serviceManagementCard'" class="sm-card">
            <div class="sm-card-body" *ngFor="let unitItem of state?.unit">
              <div class="sm-card-body-section" *ngFor="let detailItem of unitItem?.details; let i = index"
                [ngClass]="{'left-border': ( i % 2 !== 0 && i > 0 ), 'right-border': ( i % 2 === 0 && i > 0 )}">
                <div class="sm-card-body-top">
                  <div class="sm-card-header">
                    {{ detailItem.header ? (detailItem.header | roundoffDecimal : 0) + (isScheduleMaintenance ? '' : '%') : '' }}
                  </div>
                  <div *ngIf="detailItem.label" class="sm-card-label">
                    {{ detailItem.label }}
                  </div>
                </div>
                <div class="sm-card-description">
                  {{ detailItem.description.label }}
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isServiceView && state?.deviation" class="deviation" [ngClass]="{'positive': state?.deviationSign, 'negative': !state?.deviationSign}">
          <hr class="horizontal">
          <img [src]="state?.deviationSign ? '/assets/images/ic12-arrow-up-green.svg' : '/assets/images/ic12-arrow-down.svg'" tabindex="0" alt="deviation" />
          <span class="deviation-left">{{ state?.deviation | roundoffDecimal : 0 }}</span>
        </div>
        <div *ngIf="isIwTelematics">
          <hr />
            <div class="w-100" *ngIf="isIwTelematics">
              <div class="telematics-card gap-3 align-items-center" tabindex="-1">
                <div class="icon-size">
                  <img
                    src="/assets/images/ic_truck_count.svg"
                    alt="Truck Image"
                  /> </div>
                <div class="Days-labels">
                <span >{{
                  isIwTelematicsNotReporting
                    ? state?.iwTelematicsData?.notReporting?.unitsNotReportingFiltered
                    : isIwTelematicsByPassed
                    ? state?.iwTelematicsData?.bypassed?.unitsBypassedFiltered
                    : " "
                }}</span>
                 <span class="Days-not-reporting">
                  {{
                    isIwTelematicsNotReporting
                      ? daysNotReporting
                      : isIwTelematicsByPassed
                      ? daysByPassed
                      : " "
                  }}
                </span>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
